// Whether a product is had once, not counted: what plays or downloads (access
// to content, a file) is in the cart or not — no 2 of it, so no +/- either.
// A physical product (one more copy) and a licence (one more key, one more
// seat) are bought in numbers (utils/productUtils isRepeatPurchase).
import { isRepeatPurchase, profileOf } from "../utils/productUtils"

export default function useSingleCopy(product) {
  if (!product) return false
  // nothing yet says what it is (sent without its profile): counted, as
  // before, until it is known
  const known = !!profileOf(product) || product.isPhysicalProduct !== undefined || product.contentTypeData?.isPhysical !== undefined
  if (!known) return false
  return !isRepeatPurchase(product)
}
